/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DashboardList } from '../models/dashboard-list';
@Injectable({
  providedIn: 'root',
})
class DashboardListService extends __BaseService {
  static readonly DashboardListGetDashboardListsPath = '/api/DashboardList/GetDashboardLists';
  static readonly DashboardListGetDashboardListPath = '/api/DashboardList/GetDashboardListById/{customerId}/{id}';
  static readonly DashboardListGetDashboardListToPlayPath = '/api/DashboardList/GetDashboardListToPlay';
  static readonly DashboardListGetPublicDashboardListPath = '/api/DashboardList/GetPublicDashboardList';
  static readonly DashboardListUpdateDashboardListPath = '/api/DashboardList/UpdateDashboardList';
  static readonly DashboardListPublishToPublicPath = '/api/DashboardList/PublishToPublic';
  static readonly DashboardListUnPublishToPublicPath = '/api/DashboardList/UnPublishToPublic';
  static readonly DashboardListAddDashboardListPath = '/api/DashboardList/AddDashboardList';
  static readonly DashboardListRemoveDashboardListPath = '/api/DashboardList/RemoveDashboardList';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  DashboardListGetDashboardListsResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<DashboardList>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DashboardList/GetDashboardLists`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DashboardList>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DashboardListGetDashboardLists(customerId?: number): __Observable<Array<DashboardList>> {
    return this.DashboardListGetDashboardListsResponse(customerId).pipe(
      __map(_r => _r.body as Array<DashboardList>)
    );
  }

  /**
   * @param params The `DashboardListService.DashboardListGetDashboardListParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  DashboardListGetDashboardListResponse(params: DashboardListService.DashboardListGetDashboardListParams): __Observable<__StrictHttpResponse<DashboardList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DashboardList/GetDashboardListById/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardList>;
      })
    );
  }
  /**
   * @param params The `DashboardListService.DashboardListGetDashboardListParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  DashboardListGetDashboardList(params: DashboardListService.DashboardListGetDashboardListParams): __Observable<DashboardList> {
    return this.DashboardListGetDashboardListResponse(params).pipe(
      __map(_r => _r.body as DashboardList)
    );
  }

  /**
   * @param params The `DashboardListService.DashboardListGetDashboardListToPlayParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  DashboardListGetDashboardListToPlayResponse(params: DashboardListService.DashboardListGetDashboardListToPlayParams): __Observable<__StrictHttpResponse<DashboardList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DashboardList/GetDashboardListToPlay`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardList>;
      })
    );
  }
  /**
   * @param params The `DashboardListService.DashboardListGetDashboardListToPlayParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  DashboardListGetDashboardListToPlay(params: DashboardListService.DashboardListGetDashboardListToPlayParams): __Observable<DashboardList> {
    return this.DashboardListGetDashboardListToPlayResponse(params).pipe(
      __map(_r => _r.body as DashboardList)
    );
  }

  /**
   * @param identifier undefined
   */
  DashboardListGetPublicDashboardListResponse(identifier?: null | string): __Observable<__StrictHttpResponse<DashboardList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (identifier != null) __params = __params.set('identifier', identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DashboardList/GetPublicDashboardList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardList>;
      })
    );
  }
  /**
   * @param identifier undefined
   */
  DashboardListGetPublicDashboardList(identifier?: null | string): __Observable<DashboardList> {
    return this.DashboardListGetPublicDashboardListResponse(identifier).pipe(
      __map(_r => _r.body as DashboardList)
    );
  }

  /**
   * @param dashboardList undefined
   */
  DashboardListUpdateDashboardListResponse(dashboardList: DashboardList): __Observable<__StrictHttpResponse<DashboardList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboardList;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/DashboardList/UpdateDashboardList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardList>;
      })
    );
  }
  /**
   * @param dashboardList undefined
   */
  DashboardListUpdateDashboardList(dashboardList: DashboardList): __Observable<DashboardList> {
    return this.DashboardListUpdateDashboardListResponse(dashboardList).pipe(
      __map(_r => _r.body as DashboardList)
    );
  }

  /**
   * @param dashboardListId undefined
   */
  DashboardListPublishToPublicResponse(dashboardListId?: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (dashboardListId != null) __params = __params.set('dashboardListId', dashboardListId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DashboardList/PublishToPublic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param dashboardListId undefined
   */
  DashboardListPublishToPublic(dashboardListId?: number): __Observable<boolean> {
    return this.DashboardListPublishToPublicResponse(dashboardListId).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param dashboardListId undefined
   */
  DashboardListUnPublishToPublicResponse(dashboardListId?: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (dashboardListId != null) __params = __params.set('dashboardListId', dashboardListId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DashboardList/UnPublishToPublic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param dashboardListId undefined
   */
  DashboardListUnPublishToPublic(dashboardListId?: number): __Observable<boolean> {
    return this.DashboardListUnPublishToPublicResponse(dashboardListId).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param dashboardList undefined
   */
  DashboardListAddDashboardListResponse(dashboardList: DashboardList): __Observable<__StrictHttpResponse<DashboardList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dashboardList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DashboardList/AddDashboardList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardList>;
      })
    );
  }
  /**
   * @param dashboardList undefined
   */
  DashboardListAddDashboardList(dashboardList: DashboardList): __Observable<DashboardList> {
    return this.DashboardListAddDashboardListResponse(dashboardList).pipe(
      __map(_r => _r.body as DashboardList)
    );
  }

  /**
   * @param params The `DashboardListService.DashboardListRemoveDashboardListParams` containing the following parameters:
   *
   * - `dashboardListId`:
   *
   * - `customerId`:
   */
  DashboardListRemoveDashboardListResponse(params: DashboardListService.DashboardListRemoveDashboardListParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.dashboardListId != null) __params = __params.set('dashboardListId', params.dashboardListId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/DashboardList/RemoveDashboardList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `DashboardListService.DashboardListRemoveDashboardListParams` containing the following parameters:
   *
   * - `dashboardListId`:
   *
   * - `customerId`:
   */
  DashboardListRemoveDashboardList(params: DashboardListService.DashboardListRemoveDashboardListParams): __Observable<boolean> {
    return this.DashboardListRemoveDashboardListResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module DashboardListService {

  /**
   * Parameters for DashboardListGetDashboardList
   */
  export interface DashboardListGetDashboardListParams {
    id: number;
    customerId: number;
  }

  /**
   * Parameters for DashboardListGetDashboardListToPlay
   */
  export interface DashboardListGetDashboardListToPlayParams {
    id?: number;
    customerId?: number;
  }

  /**
   * Parameters for DashboardListRemoveDashboardList
   */
  export interface DashboardListRemoveDashboardListParams {
    dashboardListId?: number;
    customerId?: number;
  }
}

export { DashboardListService }
